import { AvailableToPurchaseFlag, ProductVariantViewModel } from '@/types/api'

import { VendorDetails } from '../context/types'

interface Params {
    activeVariant: ProductVariantViewModel | null
    hasAtLeastOnePharmacy: boolean
    isFullyShipBySeller: boolean
    isFullyWithLeadTime: boolean
    isFullyWithoutShipBySeller: boolean
    minimumLeadTime: number
    hasNoVariantOptions: boolean
}

export const generateVendorDetails = ({
    activeVariant,
    hasAtLeastOnePharmacy,
    isFullyShipBySeller,
    isFullyWithLeadTime,
    isFullyWithoutShipBySeller,
    minimumLeadTime,
    hasNoVariantOptions,
}: Params): VendorDetails => {
    let tooltipText = ''
    let leadTimeText = ''
    let vendorText = ''

    if (activeVariant) {
        const leadTime = activeVariant.leadTime
        const isPharmacy = activeVariant.flags?.includes(AvailableToPurchaseFlag.Pharmacy)
        const isShipBySeller = activeVariant.shipBySeller
        const vendorDisplayName = activeVariant.vendorDisplayName

        if (isPharmacy) {
            tooltipText = 'این محصول توسط داروخانه‌های معتبر تامین می‌شود و خانومی نقش واسطه دارد.'
        }

        if (!isPharmacy && isShipBySeller) {
            tooltipText = 'این محصول مستقیماً توسط فروشنده ارسال می‌شود و در مرسوله‌ای جدا به دست شما خواهد رسید.'
        }

        if (isPharmacy) {
            vendorText = vendorDisplayName ? `فروشنده ${vendorDisplayName}` : 'فروشنده این محصول یک داروخانه است.'
        }

        if (!isPharmacy && isShipBySeller && vendorDisplayName) {
            vendorText = `فروشنده ${vendorDisplayName}`
        }

        if (isShipBySeller) {
            leadTimeText = leadTime ? `ارسال توسط فروشنده از ${leadTime} روز دیگر` : 'ارسال توسط فروشنده'
        } else {
            leadTimeText = leadTime ? ` ارسال از ${leadTime} روز دیگر` : ''
        }

        return { tooltipText, leadTimeText, vendorText }
    }

    if (hasNoVariantOptions) {
        return { tooltipText, leadTimeText, vendorText }
    }

    if (hasAtLeastOnePharmacy) {
        vendorText = 'فروشنده این محصول یک داروخانه است.'
        tooltipText = 'این محصول توسط داروخانه‌های معتبر تامین می‌شود و خانومی نقش واسطه دارد.'
    }

    if (!hasAtLeastOnePharmacy) {
        if (isFullyShipBySeller) {
            vendorText = 'ارسال توسط فروشنده'
            tooltipText = 'این محصول مستقیماً توسط فروشنده ارسال می‌شود و در مرسوله‌ای جدا به دست شما خواهد رسید.'
        }

        if (isFullyWithoutShipBySeller && isFullyWithLeadTime) {
            leadTimeText = `ارسال از ${minimumLeadTime} روز دیگر`
        }
    }

    return { tooltipText, leadTimeText, vendorText }
}
